export const getFormattedPrice = (price: number): string => new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(price).replace(/\D00(?=\D*$)/, '');
